module.exports = __webpack_public_path__ + "static/media/024 - Minutes Final 1st Workshop.6c81320f.pdf";